import React, { useMemo } from 'react';
import { RoundPrice } from '../../logic/Utility/CalculationUtilities';

const UsdNumber = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export const Price = ({
	price,
}: {
	price: number;
}) => 
{
	return (
		<span>
			{UsdNumber.format(RoundPrice(price))}
		</span>
	);
};

export const PerUnit = ({
	unit,
}: {
	unit: 'Bag' | 'Acre';
}) => 
{
	return (
		<span>
			{unitToLabel[unit]}
		</span>
	);
};

const unitToLabel = {
	'Bag': 'Bag',
	'Acre': 'Ac',
};